module.exports = __webpack_public_path__ + "img/segundaCampaSolidaria.1e42d918.jpg";